<template>
  <FilterSingleChip
    is-text
    :label-mode="labelMode"
    icon="user"
    :label="$t('search-filters.creator')"
    :items="items"
    :value="value || null"
    @change="$emit('change', $event)"
  />
</template>

<script>
import FilterSingleChip from '@/components/filters/FilterSingleChip';
import { LABEL_MODE } from '@/components/filters/label-mode';

/**
 * Creator/author dimension chip. Presentational: `:value` (user id|null) + `:users` (the roster
 * the page owns) in, `change` out. Single-select, sorted by name. Icon chip — the label doubles
 * as the hover tooltip.
 */
export default {
  name: 'CreatorChip',
  components: { FilterSingleChip },
  props: {
    value: { type: [String, Number], default: null },
    users: { type: Array, default: () => [] },
  },
  computed: {
    labelMode: () => LABEL_MODE.VALUE,
    items() {
      return (this.users || [])
        .slice()
        .sort((a, b) => a.fullName.localeCompare(b.fullName))
        .map((user) => ({ value: user.id, text: user.fullName }));
    },
  },
};
</script>
